import { ILegalAcknowledgementData } from "models/legalAcknowledgement.models";
import { TCurrentUser, TUser } from "models/users.models";
import { QueryAPIKey } from "utils/constants/api.constants";
import queries from "../../queries";

export const userQueryConfig = {
  getCurrentUser: {
    query: queries.user.currentUser,
    queryKey: [QueryAPIKey.GetCurrentUser],
    errorMessageKey: "getCurrentUserFailure",
    queryOptions: {
      select: ({ currentUser }: { currentUser: TCurrentUser }): TCurrentUser =>
        currentUser ?? {},
    },
  },
  getUser: {
    query: queries.user.user,
    queryKey: [QueryAPIKey.GetUser],
    errorMessageKey: "getUserDataFailure",
    queryOptions: {
      select: ({ user }: { user: TUser }): TUser => user ?? {},
    },
  },
  getLegalAcknowledgements: {
    query: queries.user.legalAcknowledgements,
    queryKey: [QueryAPIKey.GetLegalAcknowledgements],
    errorMessageKey: "getUserLegalAcknowledgementsDataFailure",
    queryOptions: {
      select: ({
        legalAcknowledgements,
      }: {
        legalAcknowledgements: ILegalAcknowledgementData[];
      }): ILegalAcknowledgementData[] => legalAcknowledgements ?? [],
    },
  },
};
